<highcharts-chart [Highcharts] = "highcharts" [options] = "chartOptions"
   style = "height: 300px; display: block; margin: 0 8px; border-bottom-left-radius: 20px; border-bottom-right-radius: 20px;">
</highcharts-chart>
